import { useState, useCallback, useEffect } from 'react'

const DELETE_KEY = [8, 46]

export const useMultiplePaths = (initialPaths = [], onSave) => {
  const [paths, setPaths] = useState([])

  useEffect(() => {
    setPaths(initialPaths)
  }, [initialPaths])

  const handleAdd = useCallback((newPath) => setPaths((prevPaths) => [...prevPaths, newPath]), [])

  const handleRemove = useCallback(
    (index) => {
      const newPaths = paths.filter((_, i) => i !== index)
      setPaths(newPaths)
      onSave(newPaths)
    },
    [paths, onSave]
  )

  const handleChange = useCallback((value, index) => {
    setPaths((prevPaths) => {
      const newPaths = [...prevPaths]
      newPaths[index] = { ...newPaths[index], path: value }
      return newPaths
    })
  }, [])

  const handleBlur = useCallback(() => {
    if (onSave) {
      const filteredPaths = paths.filter((e) => e.path.trim() !== '')
      onSave(filteredPaths)
    }
  }, [paths, onSave])

  const handleEnterKey = useCallback((e) => {
    if (e.key === 'Enter') e.target.blur()
  }, [])

  const handleKeyUp = useCallback((e) => {
    if (DELETE_KEY.includes(e.keyCode)) e.stopPropagation()
  }, [])

  return {
    paths: paths || [],
    setPaths,
    handleChange,
    handleRemove,
    handleAdd,
    handleBlur,
    handleKeyDown: handleEnterKey,
    handleKeyUp: handleKeyUp,
  }
}
